<div class="toggle-switch">
    <input type="checkbox" [id]="name" class="checkbox" (click)="toggleClick($event)" #checkBox />
    <label [for]="name" class="switch" [class.checked]="checked">
        <div class="slider" [class.checked]="checked">
            <span class="checkmark" [class.checked]="checked">✔</span>
            <span class="minus" [class.checked]="checked">-</span>
        </div>
    </label>
</div>
